module.exports = __webpack_public_path__ + "static/media/05BMCAmuralprogress.0c43b7ce.webp";